import React from 'react';
import styled from 'styled-components/macro';
import { withStyles } from '@material-ui/styles';
import MuiDialogActions from '@material-ui/core/DialogActions';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

import { border, borderRadius, boxShadow } from 'variables/general';
import Button from 'components/ui/Button';
import { grey50, white } from 'variables/colors';
import GhsLogo from '../../../assets/images/logo-ghs-full-width.svg';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-bottom: auto;
  padding-bottom: 5em;
  overflow-y: auto;
  background-color: ${white};
  border-radius: ${borderRadius};
  box-shadow: ${boxShadow};

  @media (min-width: 30em) {
    height: ${({ fullHeight }) => (fullHeight ? '100%' : 'calc(100% - 5em)')};
    max-width: ${({ maxWidth }) => maxWidth || '40em'};
    max-height: ${({ maxHeight }) => maxHeight || '38em'};
    margin-bottom: 0;
    padding-bottom: 0;
    overflow: hidden;
  }
`;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const OrganizationLogo = styled.img`
  max-width: 12em;
  height: 4em;
  margin: 2em 0 3em;
`;

const Logo = styled.img`
  position: absolute;
  top: 3em;
  left: 3em;
  display: none;
  width: 13em;

  @media (min-width: 30em) {
    display: block;
  }
`;

const NextButton = styled(Button)`
  margin-left: auto;
`;

const DialogActions = withStyles(() => ({
  root: {
    zIndex: 100,
    position: 'fixed',
    height: '5em',
    bottom: 0,
    backgroundColor: white,
    padding: '0 1em',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginTop: 'auto',
    borderTop: border,

    '@media (min-width: 30em)': {
      position: 'unset',
    },
  },
}))(MuiDialogActions);

const BackButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    color: ${grey50};
  }
`;

const ScheduleAppointmentModal = ({
  logo,
  children,
  nextButtonDisabled,
  handlePrev,
  handleNext,
  cancel,
  buttonText,
  empty,
  maxWidth,
  maxHeight,
}) => {
  let buttonLabel = 'Next';

  if (buttonText) {
    buttonLabel = buttonText;
  }

  return (
    <>
      <Logo src={GhsLogo} alt="GHS Logo" />

      <Content maxWidth={maxWidth} maxHeight={maxHeight}>
        {logo && <OrganizationLogo src={logo} alt="Organization Logo" />}

        <FormWrapper>{children}</FormWrapper>

        {!empty && (
          <DialogActions>
            {handlePrev && (
              <BackButton onClick={handlePrev}>
                <ChevronLeftIcon fontSize="small" />
                Back
              </BackButton>
            )}

            <NextButton
              onClick={handleNext}
              className=""
              disabled={nextButtonDisabled}
              variant={cancel ? 'outlined' : 'contained'}
              color={cancel ? 'error' : 'primary'}
            >
              {buttonLabel}
            </NextButton>
          </DialogActions>
        )}
      </Content>
    </>
  );
};

export default ScheduleAppointmentModal;
